import { Injectable, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import {
    CanActivate,
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { Observable } from 'rxjs';
import { WINDOW } from '../models/tokens';

interface GaWindow extends Window {
    ga: (...args: any[]) => void;
}

// declare let window: GaWindow;

@Injectable({
    providedIn: 'root',
})
export class AnalyticsGuard implements CanActivate, CanActivateChild {
    private lastLocation = '';
    private readonly maxGaRetryCount = 10;
    private gaRetryCount = 0;

    constructor(
        private ngZone: NgZone,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(WINDOW) private window: GaWindow,
    ) {}

    initialLoad() {
        const location = this.window.location.href;
        if (this.window.ga) {
            if (location !== this.lastLocation) {
                this.window.ga('send', 'pageview', {
                    page: this.window.location.href,
                });
            }
            this.lastLocation = this.window.location.href;
            this.gaRetryCount = 0;
        } else {
            if (this.gaRetryCount >= this.maxGaRetryCount) {
                return;
            }

            this.gaRetryCount += 1;
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.initialLoad();
                }, 500);
            });
        }
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (isPlatformBrowser(this.platformId)) {
            if (this.window.ga) {
                this.window.ga('send', 'pageview', {
                    page: this.window.location.href,
                });
            } else {
                this.initialLoad();
            }
        }
        return true;
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.canActivate(route, state);
    }
}
